import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { t } from "i18next";
import { useSelector } from "react-redux";
import { useOutletContext } from "react-router-dom";

const Payouts = ({ available, eventCount }) => {
  const { event, eventLoading, selectedLanguage } = useOutletContext();
  const { session } = useSelector((state) => state?.authProvider);
  const stripe_account =
    session?.user?.paymentAccounts?.find(
      (acc) => acc?.provider === "stripe" && acc?.providerType === "account"
    )?.metadata?.id || null;

  const { data: payoutData, isLoading } = useQuery({
    queryKey: ["payout-stripe", stripe_account],
    enabled: !!stripe_account,
    queryFn: async () => {
      try {
        const res = await axios.get(
          `https://api.stripe.com/v1/payouts?limit=2000`,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_KEY}`,
              "Stripe-Account": stripe_account,
            },
          }
        );
        const payouts = res?.data?.data || [];

        const paid = payouts.filter((payout) => payout.status === "paid");
        const pending = payouts.filter((payout) => payout.status === "pending");

        return { all: payouts, paid, pending };
      } catch (error) {
        throw new Error(
          error.response?.data?.error?.message || "Stripe API error"
        );
      }
    },
  });

  const payoutSummary = [
    {
      label: t("Paid"),
      // amount: `${event?.data?.currency?.code||""} ${parseFloat(
      //   (payoutData?.paid?.reduce((acc, current) => acc + current?.amount, 0) ||
      //     0) / 100
      // ).toFixed(2)}`,
      amount: `${event?.data?.currency?.code || ""} ${(
        eventCount?.netSales || 0
      )?.toFixed(2)}`,
      textColor: "text-emerald-600",
    },
    {
      label: t("Remaining"),
      // amount: `${event?.data?.currency?.code||""} ${parseFloat(
      //   (payoutData?.pending?.reduce(
      //     (acc, current) => acc + current?.amount,
      //     0
      //   ) || 0) / 100
      // ).toFixed(2)}`,
      amount: `${event?.data?.currency?.code || ""} ${(
        eventCount?.pendingPayout || 0
      )?.toFixed(2)}`,
      textColor: "text-cyan-600",
    },
    // {
    //   label: "Event Adjustments",
    //   amount: "${event?.data?.currency?.code||""} 0.00",
    //   textColor: "text-amber-600",
    // },
  ];

  return (
    <div className="group relative shadow rounded-lg cursor-pointer transition-all duration-300 border border-transparent flex flex-col px-2 md:px-5 py-2 md:py-5 h-full mb-8">
      <div className="flex items-center gap-4 mb-8">
        <div className="flex-shrink-0 flex items-center justify-center w-12 md:w-16 aspect-square rounded-lg bg-primary/10 text-primary text-3xl">
          <i className="fa-light fa-wallet"></i>
        </div>
        <h2 className="text-2xl font-bold text-deep-purple font-Montserrat">
          {t("Payouts")}
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-4 mb-8">
        {payoutSummary?.map((item, idx) => (
          <div
            key={idx}
            className="group relative shadow rounded-lg cursor-pointer transition-all duration-300 hover:shadow-xl hover:shadow-primary/10 border border-transparent hover:border-primary/10 hover:no-underline flex flex-col px-5 py-5 h-full"
          >
            <div
              className={`text-base font-bold text-slate-900 group-hover:text-primary transition-all duration-300 leading-tight`}
            >
              {item.amount}
            </div>
            <div className="text-sm text-slate-500">{item.label}</div>
          </div>
        ))}
      </div>

      {/* <div className="group relative shadow rounded-lg cursor-pointer transition-all duration-300 border border-transparent flex flex-col md:px-5 md:py-5 h-full">
        <div className="text-sm text-deep-purple mb-2">{available.label}</div>
        <div className="text-2xl font-bold text-deep-purple mb-2">
          {available.amount}
        </div>
        <div className="text-xs text-deep-purple">{available.note}</div>
      </div> */}

      {/* <div className="space-y-4">
        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-2xl border border-gray-200">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0 flex items-center justify-center w-16 aspect-square rounded-lg bg-primary/10 text-primary text-3xl">
              <i className="fa-light fa-user "></i>
            </div>
            <span className="text-deep-purple font-medium">{accountInfo}</span>
          </div>
          <button className="text-deep-purple transition-colors font-medium">
            Manage account →
          </button>
        </div>

        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-2xl border border-gray-200">
          <span className="text-gray-600">Recent payment</span>
          <span className="text-gray-500">{recentPayment}</span>
        </div>
      </div> */}
    </div>
  );
};

export default Payouts;
